import styled from 'styled-components'

export default styled.div`
    display: none;
    position: absolute;
    left: 238px;
    top: 0px;
    color: white;
    font-size: 0.8em;
    line-height: 1.4em;
    padding: 5px;
    background-color: #555;
    min-width: 300px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
`